import React from 'react';
import { Link } from 'react-router-dom';
import SectionReveal from '../ui/SectionReveal';
import PageHeader from '../ui/PageHeader';
import BuyCard from '../ui/BuyCard';
import Contracts from '../ui/Contracts';
import Seo from '../ui/Seo';

const OPTIONS = [
  { to: '/buy/arbitrum', emoji: '🔵', title: 'Buy on Arbitrum', tag: 'Recommended', body: 'Trade directly on the Arbitrum network with OpenOcean or CamelotDex.' },
  { to: '/buy/evm', emoji: '🌉', title: 'Buy from any EVM chain', body: 'Ethereum L1, Base, OP and more: swap and bridge in one go with HermesOmnichain.' },
  { to: '/buy/solana', emoji: '🟣', title: 'Buy on Solana', body: 'Trade the Wormhole-bridged BOOP on Jupiter or Raydium.' },
];

const BuyPage = () => (
  <main className="wrap">
    <Seo title="Buy $BOOP" description="How to buy $BOOP on Arbitrum, Solana, or any EVM chain." path="/buy" />
    <PageHeader eyebrow="💸 BUY" title="Get your" highlight="$BOOP" sub="The fastest route is Relay: pick a chain and go. Prefer doing it yourself? Pick a step-by-step guide below." />

    <section className="grid items-start gap-6 pt-7 lg:grid-cols-2 lg:gap-10 lg:pt-12">
      <SectionReveal id="buy">
        <BuyCard />
      </SectionReveal>
      <SectionReveal delay={0.06}>
        <Contracts alwaysShowTitle />
      </SectionReveal>
    </section>

    <section className="pt-10 lg:pt-16" aria-labelledby="buy-guides">
      <h2 id="buy-guides" className="card-title">
        Choose your preferred network
      </h2>
      <div className="grid gap-3.5 sm:grid-cols-2 lg:gap-5">
        {OPTIONS.map((o, i) => (
          <SectionReveal key={o.to} delay={i * 0.05} className="h-full">
            <Link
              to={o.to}
              className="flex h-full items-start gap-3 rounded-2xl border-[3px] border-ink bg-paper px-4 py-4 no-underline shadow-hard transition-transform hover:-translate-y-0.5 active:translate-x-0.5 active:translate-y-0.5 active:shadow-none lg:px-5 lg:py-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-[3px] border-ink bg-sun text-xl">{o.emoji}</span>
              <span className="min-w-0 flex-1">
                <span className="flex flex-wrap items-center gap-2 text-lg font-bold lg:text-xl">
                  {o.title}
                  {o.tag && <span className="chip !bg-sun">{o.tag}</span>}
                </span>
                <span className="mt-0.5 block text-sm lg:text-[15px]">{o.body}</span>
              </span>
              <span className="shrink-0 text-xl font-bold" aria-hidden="true">
                →
              </span>
            </Link>
          </SectionReveal>
        ))}
      </div>
    </section>
  </main>
);

export default BuyPage;
